import BBrowser from "../../core/bbclient/browser";
import { SyncMessage } from "../db/models/synchronizer";
import { ApiCallResponse } from "../app/api";
import { BaseDatabase } from "../db";

const bbSyncPlugin = BBrowser.plugin('bb-sync');

export function cleanupPullMessages(token: string) {
    return new Promise<void>((resolve, reject) => {
        if (bbSyncPlugin.api.info.plugins['bb-sync'] == undefined) {
            resolve();
        }

        const doneHandler = () => {
            resolve();
            bbSyncPlugin.off('cleanupDone', doneHandler);
            bbSyncPlugin.off('cleanupError', errorHandler);
        };

        const errorHandler = error => {
            reject(error);
            bbSyncPlugin.off('cleanupDone', doneHandler);
            bbSyncPlugin.off('cleanupError', errorHandler);
        };

        bbSyncPlugin.on('cleanupDone', doneHandler);
        bbSyncPlugin.on('cleanupError', errorHandler)

        bbSyncPlugin.call('cleanup', {token: token});
    });
}

export function isBBSyncEnabled() {
    return new Promise<boolean>((resolve, reject) => {
        if (bbSyncPlugin.api.info.plugins['bb-sync'] == undefined) {
            resolve(false);
        }

        const doneHandler = (status) => {
            resolve(status.status);
            bbSyncPlugin.off('statusMessage', doneHandler);
            bbSyncPlugin.off('statusError', errorHandler);
        };

        const errorHandler = error => {
            reject(error);
            bbSyncPlugin.off('statusMessage', doneHandler);
            bbSyncPlugin.off('statusError', errorHandler);
        };

        bbSyncPlugin.on('statusMessage', doneHandler);
        bbSyncPlugin.on('statusError', errorHandler)

        bbSyncPlugin.call('status');
    });
}

export interface SyncStatusMessage {
    readonly message: string;
    readonly level: string;
    readonly timestamp: string;
}

export enum SyncStatusMessageLevel {
    Diagnostics = 'Diagnostics',
    Information = 'Information',
    Error = 'Error',
}


export async function getBBSyncStatusMessages(options?: {from?: number, to?: number}): Promise<{message: string, level: SyncStatusMessageLevel, timestamp: string}[]> {   
    if (bbSyncPlugin.api.info.plugins['bb-sync'] == undefined) {
        return [];
    }
    
    return await new Promise((resolve, reject) => {
        const syncMessagesDoneHandler = (results) => {
            bbSyncPlugin.off('syncMessagesDone', syncMessagesDoneHandler);
            resolve(results);
        }
        bbSyncPlugin.on('syncMessagesDone', syncMessagesDoneHandler);
        bbSyncPlugin.on('syncMessagesError', reject);
        bbSyncPlugin.call('messages', options);
    });
}

export function fileSyncPush(token: string, messages: SyncMessage[]) {
    return new Promise<void>((resolve, reject) => {
        if (bbSyncPlugin.api.info.plugins['bb-sync'] == undefined) {
            resolve();
        }

        const doneHandler = () => {
            resolve();
            bbSyncPlugin.off('pushDone', doneHandler);
            bbSyncPlugin.off('pushError', errorHandler);
        };

        const errorHandler = error => {
            reject(error);
            bbSyncPlugin.off('pushDone', doneHandler);
            bbSyncPlugin.off('pushError', errorHandler);
        };

        bbSyncPlugin.on('pushDone', doneHandler);
        bbSyncPlugin.on('pushError', errorHandler)

        bbSyncPlugin.call('push', {token: token, messages: messages});
    });
}

export function fileSyncPull(token: string, db: BaseDatabase) {
    return new Promise<ApiCallResponse>((resolve, reject) => {
        if (bbSyncPlugin.api.info.plugins['bb-sync'] == undefined) {
            console.warn('fileSyncPull: bb-sync is not set, aborting');
            return resolve(<never>[]);
        }

        const doneHandler = (messages) => {
            console.log('fileSyncPull: doneHandler', messages);
            resolve(JSON.parse(messages.messages));
            bbSyncPlugin.off('pullDone', doneHandler);
            bbSyncPlugin.off('pullError', errorHandler);
        };

        const errorHandler = error => {
            console.error('fileSyncPull: errorHandler', error);
            reject(error);
            bbSyncPlugin.off('pullDone', doneHandler);
            bbSyncPlugin.off('pullError', errorHandler);
        };

        bbSyncPlugin.on('pullDone', doneHandler);
        bbSyncPlugin.on('pullError', errorHandler);

        console.log('fileSyncPull: Beginning to load attributes from the database...');
        Promise.all([
            db.Attribute.toArray(),
        ]).then((results) =>
        {
            const payload = {token: token, attributes: JSON.stringify(results)};
            console.log('fileSyncPull: Calling plugin pull', payload);
            bbSyncPlugin.call('pull', payload);
        });
    });
}
